export default {
    path: '/forget-password',
    name: 'forget-password',
    component: () =>
        import(
            /* webpackChunkName: "forget-password" */ '@/views/auth/ForgetPassword.vue'
        ),
    meta: {
        layout: 'simple-layout',
        guest: true,
    },
}
